import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';
import LoadingSpinner from '../layout/LoadingSpinner';

export default function PublicRoute() {
  const [authState, setAuthState] = useState('loading');

  useEffect(() => {
    let cancelled = false;
    getCurrentUser()
      .then(() => { if (!cancelled) setAuthState('authenticated'); })
      .catch(() => { if (!cancelled) setAuthState('unauthenticated'); });
    return () => { cancelled = true; };
  }, []);

  if (authState === 'loading') return <LoadingSpinner />;
  if (authState === 'authenticated') return <Navigate to="/" replace />;
  return <Outlet />;
}
